import { render, staticRenderFns } from "./reportsAdminAll.vue?vue&type=template&id=52077b92&scoped=true"
import script from "./reportsAdminAll.vue?vue&type=script&lang=js"
export * from "./reportsAdminAll.vue?vue&type=script&lang=js"
import style0 from "./reportsAdminAll.vue?vue&type=style&index=0&id=52077b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52077b92",
  null
  
)

export default component.exports